import { OrderForm } from '~domains/orders/widgets/order-form';

export const CreateOrderPage = () => {
  return <OrderForm />;
};
